type TitleSize = "sm" | "md" | "lg";

interface TitleProps {
  children: React.ReactNode;
  size?: TitleSize;
  className?: string;
}

const STYLES_BY_SIZE: Record<TitleSize, string> = {
  sm: "font-semibold tracking-tight text-lg",
  md: "font-semibold tracking-tight text-xl",
  lg: "font-semibold tracking-tight text-2xl",
};

const TAG_BY_SIZE: Record<TitleSize, keyof JSX.IntrinsicElements> = {
  sm: "h3",
  md: "h2",
  lg: "h1",
};

export const Title: React.FC<TitleProps> = ({
  children,
  size = "md",
  className = "",
}) => {
  const Tag = TAG_BY_SIZE[size];
  return (
    <Tag className={`${STYLES_BY_SIZE[size]} ${className}`.trim()}>
      {children}
    </Tag>
  );
};

export default Title;
